import React from 'react'
import { Typography, Stack } from '@mui/material'

const today = new Date()
const AuthFooter = () => (
  <Stack direction="row" justifyContent="center">
    <Typography variant="subtitle2">
      Copyright &copy; {today.getFullYear()} Adaloka.com. All right reserved.
    </Typography>
  </Stack>
)

export default AuthFooter
